import { FrmCategory } from "components/formFields/frm/FrmCategory";

export function EditCategoryFilter(props) {
  const { filters, setFilters } = props;

  const { filterSettings } = filters;
  const { Category } = filterSettings;

  function handleChange(_, value) {
    setFilters((prevParams) => ({
      ...prevParams,
      filterSettings: {
        ...prevParams.filterSettings,
        Category: value?.id || "",
      },
      startingRecord: 1,
    }));
  }

  return (
    <FrmCategory
      value={Category ? { id: +Category } : null}
      onValueChange={handleChange}
      dataTesting="categoryFilter"
    />
  );
}
